module.exports = __webpack_public_path__ + "static/media/atenttion.305c455a.svg";